import React from 'react'
import { Glyphicon } from 'react-bootstrap'
import { useT } from '@transifex/react'

const conditionals = {
  '/deliveries': (locks) => locks.filter((l) => l.type === 'box' || l.type === 'room').length > 0,
  '/rental': (locks) => locks.filter((l) => l.rental_company && l.rentalActive !== false).length > 0,
}

const SideBarItem = ({ label, goTo, locks }) => {
  const t = useT()
  const labels = {
    home: {
      path: '/',
      text: t('Home'),
      glyph: 'glyphicon glyphicon-home',
    },
    deliveries: {
      path: '/deliveries',
      text: t('Deliveries'),
      glyph: 'glyphicon glyphicon-send',
    },
    users: {
      path: '/userstab',
      text: t('Users'),
      glyph: 'glyphicon glyphicon-user',
    },
    'q&a': {
      path: 'https://www_qlocx_com/myqlocxqa',
      text: t('FAQ'),
      glyph: 'glyphicon glyphicon-question-sign',
    },
    'storage_q&a': {
      path: 'https://qlocx.com/en/faq-smart-storage',
      text: t('FAQ'),
      glyph: 'glyphicon glyphicon-question-sign',
    },
    'hilti_sv_q&a': {
      path: 'https://qlocx-public.s3.eu-west-1.amazonaws.com/FAQ+till+Qlocxs+231002.xlsx',
      text: `Hilti ${t('FAQ')}`,
      glyph: 'glyphicon glyphicon-question-sign',
    },
    lockCreator: {
      path: '/createlock',
      text: t('New Unit'),
      glyph: 'glyphicon glyphicon-plus-sign',
    },
    storageCreator: {
      path: '/createstorage',
      text: t('New Smart Storage'),
      glyph: 'glyphicon glyphicon-plus-sign',
    },
    dataanalytics: {
      path: '/data-analytics/deliverysearch',
      text: t('Q-Insight'),
      glyph: 'glyphicon glyphicon-plane',
    },
    rental: {
      path: '/rental',
      text: t('Rental'),
      glyph: 'glyphicon glyphicon-wrench',
    },
    exploring: {
      path: '/statistics',
      text: t('Statistics'),
      glyph: 'glyphicon glyphicon-stats',
    },
  }

  const item = labels[label]
  if (!item) return null

  const { path, text, glyph } = item

  if (typeof conditionals[path] === 'function' && conditionals[path](locks) === false) return null

  return (
    <div onClick={() => goTo(path)} style={{ color: '#484848', cursor: 'pointer', marginBottom: 15, fontSize: window.isMobile ? 14 : 16 }}>
      <span>{glyph ? <Glyphicon glyph={glyph} /> : null}</span>
      {window.isMobile ? null : <p>{t(text)}</p>}
    </div>
  )
}

export default SideBarItem
